import React from 'react';
import PropTypes from 'prop-types';

const ModalBodySection = ({ children, className = '', style = {} }) => {
  const baseStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px',
    ...style,
  };

  return (
    <div
      className={`modal-body-section scrollable scrollable-x ${className}`}
      style={baseStyles}
    >
      {children}
    </div>
  );
};

ModalBodySection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default ModalBodySection;
